import {
  StatusChip,
  BadgeColor,
  Text,
  Divider,
  Grid,
  Button,
  ProgressBar,
} from "@pushpress/shared-components";
import { Card } from "@pushpress/pushpress-ui";
import { PRIMARY_COLOR } from "../../../../constants/colors";
import ActionsMenu from "../shared/ActionsMenu";
import ActionItem from "../shared/ActionItem";

type AssignPlansCardType = {
  disableAssignPlans: boolean;
  migratingMembersCount: number;
  membersWithPlansCount: number;
  setShowAssignPlansPage: (value: boolean) => void;
};

export function AssignPlansCard({
  disableAssignPlans,
  migratingMembersCount,
  membersWithPlansCount,
  setShowAssignPlansPage,
}: AssignPlansCardType) {
  const membersWithPlansProgress =
    (membersWithPlansCount / migratingMembersCount) * 100;

  return (
    <Card className="tw-p-6 tw-mt-8">
      <Grid container spacing={3}>
        <Grid item>
          <StatusChip color={BadgeColor.Gray} label="Step 2" />
        </Grid>
        <Grid item>
          <Text variant="heading-4" component="h2" color="wolf-700">
            Assign plans
          </Text>
        </Grid>
        <Grid item marginY={1} xs={10}>
          <Text variant="body-lg" color="wolf-600">
            Assign plans, discounts, and start / end dates.
          </Text>
        </Grid>
        <Divider
          color="wolf-800"
          vPadding={14}
          marginLeft={24}
          marginRight={18}
        />
        <Grid
          item
          marginY={1}
          style={{ paddingBottom: "8px", marginTop: "0", marginBottom: "0" }}
        >
          <ActionsMenu>
            <ActionItem
              description="Create your plans"
              url="/plans/index"
              urlDescription="Go to plans"
            />
            <ActionItem
              description="Create discounts (optional)"
              url="/discounts/index/membership"
              urlDescription="Go to discounts"
            />
            <ActionItem
              description="Create tax rates (optional)"
              url="/settings/index"
              urlDescription="Go to settings"
            />
          </ActionsMenu>
        </Grid>
        <Divider
          color="wolf-800"
          vPadding={14}
          marginLeft={24}
          marginRight={18}
        />
        <Grid item xs={6}>
          <Button
            data-testid="assign-plans-button"
            buttonType="secondary"
            size="large"
            fullWidth
            disabled={disableAssignPlans}
            text="Assign plans"
            onClick={() => setShowAssignPlansPage(true)}
          />
        </Grid>
        <Grid item>
          <Divider vertical color="wolf-800" />
        </Grid>
        <Grid item xs={5}>
          <Text
            variant="heading-5"
            component="h5"
            style={{ marginBottom: "5px" }}
          >
            {membersWithPlansCount} / {migratingMembersCount}
          </Text>
          <ProgressBar
            label=""
            color={PRIMARY_COLOR}
            progressWidth={membersWithPlansProgress}
            height={6}
          />
        </Grid>
      </Grid>
    </Card>
  );
}
